import { render } from "./ViewClass.vue?vue&type=template&id=983fa23e&scoped=true&ts=true"
import script from "./ViewClass.vue?vue&type=script&lang=ts"
export * from "./ViewClass.vue?vue&type=script&lang=ts"

import "./ViewClass.vue?vue&type=style&index=0&id=983fa23e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-983fa23e"]])

export default __exports__